import { render, staticRenderFns } from "./RechargeHistories.vue?vue&type=template&id=477630c1"
import script from "./RechargeHistories.vue?vue&type=script&lang=ts"
export * from "./RechargeHistories.vue?vue&type=script&lang=ts"
import style0 from "./RechargeHistories.vue?vue&type=style&index=0&id=477630c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports